/**
 * Inverter rows a battery job should fill.
 *
 * An entered row is kept, including a blank row the operator saved to dismiss
 * the suggestion. When nothing has been entered, an all-in-one unit (the
 * battery make and model, plus the section 5 inverter serial) is the row.
 * Section 4 and section 6 do not supply that serial.
 */
export function resolveBatteryInverters(hardware) {
    const stored = hardware.inverters ?? [];
    if (stored.length > 0)
        return stored.map((row) => ({ ...row }));
    const battery = (hardware.batteries ?? []).find((row) => row.make?.trim() || row.model?.trim());
    if (!battery)
        return [];
    const make = battery.make?.trim();
    const model = battery.model?.trim();
    const serial = battery.systemType === 'integrated' || battery.systemType === 'other'
        ? undefined
        : battery.inverterSerial?.trim() || undefined;
    return [
        {
            ...(make ? { make } : {}),
            ...(model ? { model } : {}),
            ...(serial ? { serial } : {}),
            quantity: 1,
        },
    ];
}
//# sourceMappingURL=battery-inverters.js.map